import { z } from 'zod';

export const companyEmploymentTypesSchema = z.object({
  offersFreelanceWork: z.boolean(),
  offersTempWork: z.boolean(),
  offersEmployeeWork: z.boolean(),
});

export type GetCompanyEmploymentTypes = z.infer<typeof companyEmploymentTypesSchema>;

export const companySchema = z.object({
  id: z.string(),
  name: z.string(),
  branchOfficesCount: z.number(),
  offersFreelanceWork: z.boolean(),
  offersTempWork: z.boolean(),
  offersEmployeeWork: z.boolean(),
});

export const companiesSchema = z.array(companySchema);

export type Companies = z.infer<typeof companiesSchema>;

export const contractorCompanyRateSchema = z.object({
  jobTypeId: z.string(),
  jobTypeName: z.string(),
  freelancerRateCents: z.number().int().nullable(),
  tempWorkerRateCents: z.number().int().nullable(),
  employeeRateCents: z.number().int().nullable(),
});

export const getContractorCompanyRatesSchema = z.object({
  jobTypes: z.array(contractorCompanyRateSchema),
});

export type ContractorCompanyRate = z.infer<typeof contractorCompanyRateSchema>;

export type GetContractorCompanyRates = z.infer<typeof getContractorCompanyRatesSchema>;

export type UpdateContractorCompanyRate = {
  jobTypeId: string;
  employmentType: 'FREELANCER' | 'TEMPWORKER' | 'EMPLOYEE';
  rateCents: number | null;
};
